import { useRef, useState } from "react";
import Col from "react-bootstrap/Col";
import { useAppContext } from "../../../../_context";
import { Form, FormControl } from "react-bootstrap";
import FieldError from "../../../FieldError";

const DayRow = ({
  day,
  index,
  open = "09:00",
  close = "17:00",
  selected = true,
  allErrors = [],
}) => {
  const [{ tx }] = useAppContext();
  const [isOpen, setIsOpen] = useState(selected);
  const checkbox = useRef();

  const onChange = () => {
    setIsOpen(checkbox?.current.checked);
  };

  return (
    <div className="day-row-item row mb-2" data-index={index}>
      <Col md={4}>
        <Form.Check type="checkbox" className="day-row-checkbox-container">
          <Form.Check.Input
            ref={checkbox}
            id={`day-row-${day}`}
            type="checkbox"
            defaultChecked={isOpen}
            onChange={onChange}
            className="me-2 is-open"
          />
          <Form.Check.Label className="fw-bold" htmlFor={`day-row-${day}`}>
            {tx[day]}
          </Form.Check.Label>
        </Form.Check>
      </Col>
      <Col md={8}>
        {isOpen ? (
          <div className="row">
            <Col xs={6}>
              <FormControl
                type="time"
                defaultValue={open}
                id={`day-row-${index}-open-time`}
                className="day-row-open"
              />
            </Col>
            <Col xs={6}>
              <FormControl
                type="time"
                defaultValue={close}
                id={`day-row-${index}-close-time`}
                className="day-row-close"
              />
            </Col>
            <Col xs={12} className="text-center">
              <FieldError
                fieldName={[
                  `day-row-${index}-open-time`,
                  `day-row-${index}-close-time`,
                ]}
                allErrors={allErrors}
              />
            </Col>
          </div>
        ) : (
          <p className="mb-0 text-md-center small closed-on-day text-grey-1">
            {tx["Closed"]}
          </p>
        )}
      </Col>
    </div>
  );
};

export default DayRow;
